import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useAwakeMember } from "@/lib/awakeContext";
import { Button } from "@/components/ui/button";
import WeaveLogo from "@/components/WeaveLogo";

export default function SiteHeader() {
  const { user, logout } = useAuth();
  const { isMember, dashboardUrl } = useAwakeMember();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="w-full border-b border-[var(--line)] bg-[var(--bg)]/90 backdrop-blur sticky top-0 z-40"
    >
      <div className="section-pad py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 shrink-0">
          <WeaveLogo height={32} />
        </Link>

        <nav className="flex items-center gap-2 md:gap-5">
          <a href="#how" className="hidden md:inline text-sm hover:text-[var(--teal)]">
            How it works
          </a>
          <a href="#framework" className="hidden md:inline text-sm hover:text-[var(--teal)]">
            The audit
          </a>
          {user ? (
            <>
              <Button
                data-testid="dashboard-btn"
                variant="ghost"
                onClick={() => navigate("/app")}
                className="rounded-full"
              >
                Workspace
              </Button>
              <Button
                data-testid="logout-btn"
                onClick={logout}
                className="btn-primary rounded-full h-11 px-5"
              >
                Sign out
              </Button>
            </>
          ) : isMember ? (
            <a
              href={dashboardUrl}
              data-testid="header-member-dashboard"
              className="btn-primary rounded-full h-11 px-4 md:px-6 font-medium inline-flex items-center gap-1.5 text-sm"
            >
              ← Back to your dashboard
            </a>
          ) : (
            <div className="flex items-center gap-2">
              <a
                href="https://www.wearetheweave.co.uk/community-choice"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="header-find-out-more"
                className="hidden sm:inline-flex h-11 px-4 items-center text-sm hover:text-[var(--teal)]"
              >
                Find out more
              </a>
              <a
                href="https://awake.wearetheweave.co.uk/join"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="header-cta"
                className="btn-red rounded-full h-11 px-5 md:px-6 font-medium inline-flex items-center"
              >
                Join now
              </a>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
